import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { RouterProvider } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { SettingsProvider } from './contexts/SettingsContext';
import { router } from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const theme = createTheme({
    palette: {
        primary: { main: "#3a34d2" }
    }
});

root.render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                    <RouterProvider router={router} />
                </SettingsProvider>
            </LocalizationProvider>
        </ThemeProvider>
    </StrictMode>
);
